<div [class.card]="!presetAmount" [class.p-4]="!presetAmount">

  <ng-container *ngIf="!presetAmount">
    <h3 class="text-center mb-3">
      {{ "wallet.chargeWallet" | translate }}
    </h3>

    <div class="mb-3">
      <label class="form-label">{{ "wallet.enterAmount" | translate }}</label>
      <input type="number"
             class="form-control"
             [(ngModel)]="amount"
             placeholder="0" />
    </div>

    <button class="btn btn-primary w-100"  *ngIf="!isMoyaserInit"  (click)="initPayment()">
      {{ "wallet.pay" | translate }}
    </button>
  </ng-container>

  <div class="mysr-form" [class.mt-4]="!presetAmount"></div>

</div>
